type Env =
  | 'REACT_APP_API_URL'
  | 'REACT_APP_OAUTH2_AUTHORIZATION_URL'
  | 'REACT_APP_OAUTH2_AUTHORIZATION_TENANT_URL'
  | 'REACT_APP_OAUTH2_CLIENT_ID'
  | 'REACT_APP_OAUTH2_REDIRECT_URI'
  | 'REACT_APP_REVERB_APP_KEY'
  | 'REACT_APP_REVERB_HOST'
  | 'REACT_APP_REVERB_WSS_PORT'
  | 'REACT_APP_REVERB_PORT'
  | 'REACT_APP_REVERB_SCHEME'
  | 'REACT_APP_MIXPANEL_TOKEN';

export const env = (key: Env): string => {
  const value = process.env[key];
  if (!value) throw new Error(`${key} is not set.`);
  return value;
};
